import { InMemoryCache } from '../InMemoryCache';
import enviro from 'enviro';
export const INTEGRATION_STATUS_CONNECTED = 'CONNECTED';

/**
 * Copied from prospecting-lib
 * https://git.hubteam.com/HubSpot/prospecting-ui/commit/00652143b47d9e2d8f83ea83b156ae66a7fef00b#diff-acd0a6184047dfd714741a886e38378f251b9d31d3d5c7d57f2f8956f7cd0e89R1
 */
const LINKED_IN_SALES_NAVIGATOR_APP_ID = 42082;
const QA_LINKED_IN_SALES_NAVIGATOR_APP_ID = 1161054;
export function getLinkedInSalesNavigatorAppId() {
  return enviro.isProd() ? LINKED_IN_SALES_NAVIGATOR_APP_ID : QA_LINKED_IN_SALES_NAVIGATOR_APP_ID;
}
function fetchNativeIntegrationAppStatus(appId, httpClient) {
  return httpClient.get(`integrators/v1/portal-installs/native-statuses?appId=${encodeURIComponent(appId)}`).then(([{
    integrationStatus
  }]) => integrationStatus);
}
export const makeMarketplaceAppStatusCache = () => new InMemoryCache('MarketplaceAppStatusCache', appId => appId.toString(), ({
  httpClient
}) => appId => fetchNativeIntegrationAppStatus(appId, httpClient));